import { ensureConfig, getConfig } from "@edx/frontend-platform";
import { AppContext } from "@edx/frontend-platform/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import IIMBLogo from "../assets/images/iimb-logo.png";
import Logo from "../assets/images/logo.png";
import FooterLogo from "../assets/images/openedx.png";
import twitter from "../assets/images/twitter.png";
import linkedin from "../assets/images/linkedin.png";
import youtube from "../assets/images/youtube.png";
import instagram from "../assets/images/instagram.png";
import facebook from "../assets/images/facebook.png";
import { getAuthenticatedHttpClient } from "@edx/frontend-platform/auth";

ensureConfig(
  [
    "LMS_BASE_URL",
    "LOGOUT_URL",
    "LOGIN_URL",
    "SITE_NAME",
    "LOGO_URL",
    "ORDER_HISTORY_URL",
  ],
  "Header component"
);

const Layout = ({ children }) => {
  const { authenticatedUser, config } = useContext(AppContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [profileImage, setProfileImage] = useState(
    `${getConfig().LMS_BASE_URL}/static/images/profiles/default_50.png`
  );
  const [link, setlink] = useState("#");
  const isStaffOrInstructor = authenticatedUser?.administrator;
  /*  Tawk.to Script  */
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = 'https://embed.tawk.to/5d2ebe5d9b94cd38bbe7bfc3/default';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    return () => {
      // Cleanup the script if the component is unmounted
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (authenticatedUser) {
        try {
          console.log(`Fetching profile for user: ${config.LMS_BASE_URL}`);
          const url = `${getConfig().LMS_BASE_URL}/api/user/v1/accounts/${
            authenticatedUser?.username && authenticatedUser?.username
            }`;
          const response = await getAuthenticatedHttpClient().get(url);

          setProfileImage(response?.data?.profile_image?.image_url_small);
        } catch (error) {
          console.error("Error fetching user profile:", error);
        }
      }
    };

    fetchUserProfile();
  }, [authenticatedUser, config.LMS_BASE_URL]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  function getCookie(cookieName) {
    try {
      const cookies = document.cookie.split(';');
      for (const cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) {
          const decodedValue = decodeURIComponent(value);
          return decodedValue;
        }
      }
      return null;
    } catch (error) {
      console.error('Error reading cookie:', error);
      return null;
    }
  }

  function getResumeBlockFromCookie() {
    try {
      const edxUserInfo = getCookie('edx-user-info');

      if (!edxUserInfo) {
        return "" || "#";
      }

      const cleanedInfo = edxUserInfo?.replace(/\\"/g, '"').replace(/^"|"$/g, '') || '';

      const resumeBlockMatch = cleanedInfo?.match(/resume_block\"\s*:\s*\"([^\"]+)\"/) || [];

      if (resumeBlockMatch && resumeBlockMatch[1]) {
        const resumeBlockUrl = resumeBlockMatch[1] || '';
        return resumeBlockUrl;
      }

      return null;
    } catch (error) {
      console.error('Error extracting resume block:', error);
      return null;
    }
  }



  useEffect(() => {
    const resumeBlockUrl = getResumeBlockFromCookie();
    setlink(resumeBlockUrl || '#');
  }, []);

  useEffect(() => {
    const getCookie = (name) => {
      const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
      );
      return match ? match[2] : null;
    };

    const getRootDomain = () => {
      const host = window.location.hostname;

      if (host.endsWith('.openedx.io')) {
        return '.openedx.io';
      }
      if (host.startsWith('apps.')) {
        return host.replace(/^apps\./, '');
      }
      return null;
    };


    const setCookie = (name, value) => {
      const rootDomain = getRootDomain();

      document.cookie = `${name}=${value}; path=/;`;

      if (rootDomain) {
        document.cookie = `${name}=${value}; path=/; domain=${rootDomain};`;
      }
    };

  const LANG_MAP = {
    "ar": "ar",
    "ca": "ca",
    "es-419": "es",
    "es-es": "es",
    "fa-ir": "fa",
    "fr": "fr",
    "fr-ca": "fr-CA",
    "he": "iw",
    "id": "id",
    "ko-kr": "ko",
    "pl": "pl",
    "pt-br": "pt",
    "pt-pt": "pt-PT",
    "ru": "ru",
    "th": "th",
    "uk": "uk",
    "zh-cn": "zh-CN",
    "it-it": "it",
    "de-de": "de",
    "hi": "hi",
    "te": "te",
    "da": "da",
    "el": "el",
    "sw": "sw",
    "tr-tr": "tr",
    "bn": "bn",
    "mr": "mr",
    "ta": "ta",
    "gu": "gu",
    "kn": "kn",
    "ml": "ml",
    "pa": "pa",
    "or": "or",
    "ur": "ur",
    "sa": "sa",
    "ne": "ne",
    "sd": "sd",
  };

  const openedxLang = getCookie("openedx-language-preference");

  if (!openedxLang) return;

  const normalizedLang = openedxLang.toLowerCase();

  const gtLang =
    LANG_MAP[normalizedLang] || normalizedLang.split("-")[0];

  const googTransValue = `/en/${gtLang}`;

  setCookie("googtrans", googTransValue);
  });

  useEffect(() => {
    if (window.google?.translate) return;

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          autoDisplay: false,
        },
        'googleTranslateElement'
      );
    };

    const script = document.createElement('script');
    script.src =
      'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    script.id = 'google-translate-script';

    document.body.appendChild(script);

    return () => {
      delete window.googleTranslateElementInit;
    };
  }, []);

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light acc_header" translate="no">
        <div className="container-fluid">
          <div className="navbar-brand">
            <a href={config.LMS_BASE_URL} className="logo-container">
              <img src={IIMBLogo} alt="Logo" className="iimb-logo"/>
              <div class="divider"></div>
              <img src={Logo} alt="Logo" className="iimbx-logo"/>
            </a>
          </div>
          <div className="languages-form" id="languagesForm">
            <div id="googleTranslateElement"></div>
          </div>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav">
              <li className="nav-item dropdown" ref={dropdownRef}>
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={toggleDropdown}
                >
                  <div className="profile">
                    <img src={profileImage} alt="Profile" />
                  </div>
                  <span>{authenticatedUser?.username}</span>
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdown"
                  style={{
                    display: isDropdownOpen ? "block" : "none",
                  }}
                >
              {link && link !== '#' && (
                  <li>
                    <a className="dropdown-item" href={link}>
                      Resume your last course
                    </a>
                  </li>
              )}

                  <li>
                    <a
                      className="dropdown-item"
                      href={`${config?.LMS_BASE_URL}/dashboard`}
                    >
                      Dashboard
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={`${config?.LMS_BASE_URL}/dashboard/programs/`}
                    >
                      Programs
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={`${config?.ACCOUNT_PROFILE_URL}/u/${authenticatedUser?.username}`}
                    >
                      Profile
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href={`${config?.ACCOUNT_SETTINGS_URL}`}
                    >
                      {" "}
                      Your Account
                    </a>
                  </li>
                  {isStaffOrInstructor && (
                      <>
                        <li>
                          <a className="dropdown-item" href={`${config.LMS_BASE_URL}/learner-engagement-dashboard`}>
                            Learner Engagement Dashboard
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href={`${config.LMS_BASE_URL}/program-dashboard`}>
                            Program Dashboard
                          </a>
                        </li>
                      </>
                  )}
                  <li>
                    <a className="dropdown-item" href={config?.LOGOUT_URL}>
                      Sign Out
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <main className="main">{children}</main>

      <footer className="footer">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <div className="left-footer">
              <img src={FooterLogo} alt="Footer Logo" />
            </div>
            <div className="middle-footer">
              <ul>
                <li>© IIMBx. All rights reserved except where noted.</li>
                <li>
                  <a
                    className="dropdown-item"
                    href="https://iimbx.iimb.ac.in/privacy/"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="https://iimbx.iimb.ac.in/tos/"
                  >
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="https://iimbx.iimb.ac.in/honor/"
                  >
                    Honor Code
                  </a>
                </li>
              </ul>
            </div>
            <div className="right-footer">
              <ul className="social-media">
                <li>
                  <a href="https://www.facebook.com/iimbxonline/">
                    <img src={facebook} alt="Facebook" />
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/iimbxonline">
                    <img src={twitter} alt="Twitter" />
                  </a>
                </li>
                <li>
                  <a href="https://in.linkedin.com/company/iimbxonline">
                    <img src={linkedin} alt="LinkedIn" />
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/iimbxonline">
                    <img src={youtube} alt="YouTube" />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/iimbxonline/">
                    <img src={instagram} alt="Instagram" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Layout;
